/* Kiomia - animazioni all'ingresso.

   Due sole cose, entrambe legate allo scorrimento:
   - [data-km-su]    l'elemento sale di poco e compare, una volta sola
   - [data-km-conta] il numero parte da zero e arriva al suo valore

   La visibilita' la misuriamo con la posizione dell'elemento invece che con
   IntersectionObserver: gli elementi in gioco sono pochi, il calcolo e' una
   moltiplicazione, e cosi' funziona identico ovunque, anche dove l'osservatore
   fa i capricci (schede in secondo piano, browser vecchi, anteprime).

   Regole che ci siamo dati:
   - si animano solo elementi gia' al loro posto: niente sposta il contenuto
   - una volta sola: tornare indietro non fa ripartire nulla
   - chi ha chiesto meno animazioni nel sistema vede tutto fermo e completo
*/
(function(){
  var fermo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lista = [];
  var inCoda = false;

  function conta(el){
    var meta = parseFloat(el.getAttribute('data-km-conta')) || 0;
    var decimali = parseInt(el.getAttribute('data-km-dec'), 10) || 0;
    var durata = parseInt(el.getAttribute('data-km-durata'), 10) || 1400;
    var unita = el.getAttribute('data-km-unita') || '';
    var inizio = null;

    function scrivi(v){
      var n = decimali ? v.toFixed(decimali).replace('.', ',') : Math.round(v).toLocaleString('it-IT');
      el.textContent = n + unita;
    }
    if (fermo || !window.requestAnimationFrame){ scrivi(meta); return; }

    function passo(t){
      if (inizio === null) inizio = t;
      var q = Math.min((t - inizio) / durata, 1);
      scrivi(meta * (1 - Math.pow(1 - q, 3)));
      if (q < 1) requestAnimationFrame(passo);
    }
    requestAnimationFrame(passo);
  }

  function accendi(el){
    if (el.getAttribute('data-km-visto')) return;
    el.setAttribute('data-km-visto', '1');
    el.classList.add('is-dentro');
    if (el.hasAttribute('data-km-conta')) conta(el);
  }

  /* Dentro quando almeno un quarto dell'elemento e' nello schermo, oppure
     quando l'elemento e' piu' alto dello schermo e ne vediamo gia' un pezzo. */
  function visibile(el){
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    if (r.bottom < 0 || r.top > h) return false;
    var dentro = Math.min(r.bottom, h) - Math.max(r.top, 0);
    return dentro >= Math.min(r.height * 0.25, h * 0.3);
  }

  function controlla(){
    inCoda = false;
    for (var i = lista.length - 1; i >= 0; i--){
      if (visibile(lista[i])){
        accendi(lista[i]);
        lista.splice(i, 1);
      }
    }
  }

  function chiedi(){
    if (inCoda) return;
    inCoda = true;
    if (window.requestAnimationFrame) requestAnimationFrame(controlla);
    else setTimeout(controlla, 60);
  }

  function avvia(root){
    var nodi = (root || document).querySelectorAll('[data-km-su]:not([data-km-visto]), [data-km-conta]:not([data-km-visto])');
    if (!nodi.length) return;
    if (fermo){
      Array.prototype.forEach.call(nodi, accendi);
      return;
    }
    Array.prototype.forEach.call(nodi, function(el){ lista.push(el); });
    controlla();
  }

  window.addEventListener('scroll', chiedi, { passive: true });
  window.addEventListener('resize', chiedi);
  window.addEventListener('load', chiedi);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ avvia(document); });
  else avvia(document);
  document.addEventListener('shopify:section:load', function(e){ avvia(e.target); });

  /* Appiglio per le prove: kmAnim.controlla() forza un giro. */
  window.kmAnim = { controlla: controlla, coda: function(){ return lista.length; } };
})();
